
package com.devi3east.bashbuddy.features.common.util

import kotlinx.datetime.*

object DateTimeFormatUtil {

    private val timeZone: TimeZone
        get() = TimeZone.currentSystemDefault()

    /**
     * DATE DISPLAY
     *
     * IMPORTANT:
     * Date pickers represent a calendar day, NOT a moment in time.
     * We intentionally avoid time zones here to prevent day-shift bugs.
     */
    fun instantToDateString(instant: Instant?): String {
        if (instant == null) return ""

        val epochDays = (instant.toEpochMilliseconds() / 86_400_000L).toInt()
        val date = LocalDate.fromEpochDays(epochDays)

        val month = date.monthNumber.toString().padStart(2, '0')
        val day = date.dayOfMonth.toString().padStart(2, '0')
        val year = date.year

        return "$month/$day/$year"
    }

    /**
     * TIME DISPLAY
     *
     * Time IS timezone-sensitive and should reflect the user's local clock.
     */
    fun instantToTimeString(instant: Instant?): String {
        if (instant == null) return ""

        val time = instant
            .toLocalDateTime(timeZone)
            .time

        val hour24 = time.hour
        val minute = time.minute

        val amPm = if (hour24 < 12) "AM" else "PM"
        val hour12 = when {
            hour24 == 0 -> 12
            hour24 > 12 -> hour24 - 12
            else -> hour24
        }

        return "$hour12:${minute.toString().padStart(2, '0')} $amPm"
    }

    /**
     * DATE + TIME → INSTANT
     *
     * This is the ONLY place where a timezone should be applied.
     */
    fun combineDateAndTime(date: LocalDate, time: String): Instant? {
        val match = Regex("""^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$""")
            .find(time.trim()) ?: return null

        val (hourStr, minuteStr, amPm) = match.destructured

        var hour = hourStr.toInt()
        val minute = minuteStr.toInt()

        if (amPm.equals("PM", true) && hour < 12) hour += 12
        if (amPm.equals("AM", true) && hour == 12) hour = 0

        val localDateTime = LocalDateTime(
            date = date,
            time = LocalTime(hour, minute)
        )

        return localDateTime.toInstant(timeZone)
    }

}